.bannerWrapper {
  max-width: 100%;
  border-radius: 12px;
  margin: 2rem auto;

  &.adDefault300x250 {
    width: 300px;
    height: 250px;
  }

  &.defaultSkyScrapper {
    width: 160px;
    height: 600px;
  }

  .adBox {
    display: flex;
    justify-content: center;
    flex-flow: column;
    overflow: auto;
    background-color: var(--primitives-colors-neutral-990);
    height: 100%;

    // fix ads height
    & > span,
    & > span > iframe {
      width: 100%;
      height: 100%;
      display: block;
    }

    // fix ads color text
    :global(.mn-thumb__label-title-link) {
      color: var(--primitives-colors-neutral-400);
    }
  }

  .placeholder {
    position: relative;
    width: 100%;
    height: 100%;
    font: var(--font-caption-lg-medium);
    color: var(--primitives-colors-neutral-0);
    background-color: var(--primitives-colors-neutral-970);

    .background {
      position: absolute;
      inset: 0;
      opacity: 0.2;
    }

    .content {
      display: flex;
      justify-content: center;
      text-align: center;
      flex-direction: column;
      padding: 0.5rem;
      transform-origin: 0 0;

      & img {
        width: 100%;
        max-width: 282px;
        object-fit: contain;
        height: auto;
        max-height: 52px;
      }
    }
  }
}
